if (customElements.get("yc-product-images") === undefined) {
  class YcProductImages extends HTMLElement {
    constructor() {
      super();

      const images = this.querySelectorAll(".yc-paint-product__image");
      this.imagesContainer = this.querySelector(".yc-paint-product__images");

      this.numberOfImages = images.length;
      this.indicatorArray = [];

      // add indicators
      const indicators = this.querySelector(
        ".yc-paint-product__image-indicators"
      );
      for (let i = 0; i < images.length; i++) {
        const indicator = document.createElement("div");
        indicator.classList.add("yc-product-images__indicator");
        indicator.setAttribute("data-slide-to", i);
        if (i === 0) {
          indicator.classList.add("active");
        }
        indicators.appendChild(indicator);
        this.indicatorArray.push(indicator);

        indicator.addEventListener("click", () => {
          clearInterval(this.autoScrollInterval);
          const scrollTo =
            (this.imagesContainer.scrollWidth / this.numberOfImages) * i;
          this.imagesContainer.scrollTo({ left: scrollTo, behavior: "smooth" });
        });
      }

      // clear interval on touchstart
      this.addEventListener("touchstart", () => {
        clearInterval(this.autoScrollInterval);
      });

      this.handleScroll = this.handleScroll.bind(this);

      this.imagesContainer.addEventListener("scroll", this.handleScroll);

      this.autoScrollInterval = null;
      this.autoScroll = this.autoScroll.bind(this);
      this.autoScroll();
    }

    handleScroll() {
      // scroll percentage
      const scrollPercentage =
        this.imagesContainer.scrollLeft /
        (this.imagesContainer.scrollWidth - this.imagesContainer.clientWidth);
      const activeSlide = Math.round(
        (this.numberOfImages - 1) * scrollPercentage
      );

      this.indicatorArray.forEach((indicator, index) => {
        if (index === activeSlide) {
          indicator.classList.add("active");
        } else {
          indicator.classList.remove("active");
        }
      });
    }

    autoScroll() {
      let i = 0;
      this.autoScrollInterval = setInterval(() => {
        if (i < this.numberOfImages) {
          const scrollTo =
            (this.imagesContainer.scrollWidth / this.numberOfImages) * i;
          this.imagesContainer.scrollTo({ left: scrollTo, behavior: "smooth" });
          i++;
        } else {
          i = 0;
        }
      }, 3000);
    }
  }

  customElements.define("yc-product-images", YcProductImages);
}
